import React, { useState, useEffect } from "react";
import { Box, Typography, Card, Container, useTheme } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import CustodianTable from "./CustodianTable";
import CustodianDialog from "./CustodianDialog";
import { Helmet } from "react-helmet";
import { sendWebSocketMessage } from "../../hooks/useWebSocket";
import { selectCustodians } from "../../Redux/Reducers/selectors";

const Custodian = () => {
  const theme = useTheme();
  const [openDialog, setOpenDialog] = useState(false);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(100);

  const custodians = useSelector(selectCustodians);
  const dispatch = useDispatch();
  const handleAdd = () => {
    setRecordForEdit(null);
    setOpenDialog(true);
  };

  const handleEdit = (custodian) => {
    setRecordForEdit(custodian);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setRecordForEdit(null);
  };

  const handleSave = (custodian) => {
    if (!custodian || Object.keys(custodian).length === 0) return;

    if (recordForEdit) {
      // sendWebSocketMessage(
      //   `{"action":"modify_custodian", "data":{"custodian":${JSON.stringify({
      //     ...custodian,
      //     custodianId: recordForEdit?.custodianId,
      //     creationDate: recordForEdit?.creationDate,
      //   })}}}`
      // );
      // dispatch(addActiveRequests("modify_custodian"));
      // dispatch(updateLoading(true));
      // dispatch(updateLoadingMsg("Updating Custodian..."));
    } else {
      custodian.abbreviation = custodian.abbreviation.toLowerCase();
      if (custodians.find((a) => a.abbreviation === custodian.abbreviation)) {
        alert(`${custodian.abbreviation} already exists, try new one.`);
        return;
      }
      // sendWebSocketMessage(
      //   `{"action":"new_custodian", "data":${JSON.stringify(custodian)}}`
      // );
      // dispatch(addActiveRequests("new_custodian"));
      // dispatch(updateLoading(true));
      // dispatch(updateLoadingMsg("Adding Custodian..."));
    }

    handleCloseDialog();
  };

  const handleDelete = (custodian) => {
    if (window.confirm("Are you sure you want to delete this custodian?")) {
      // sendWebSocketMessage(
      //   `{"action":"delete_custodian", "data":{"custodian":${JSON.stringify(custodian)}}}`
      // );
      // dispatch(addActiveRequests("delete_custodian"));
      // dispatch(updateLoading(true));
      // dispatch(updateLoadingMsg("Deleting Custodian..."));
    }
  };

  return (
    <>
      <Helmet>
        <title>Custodians | Vantage Alpha</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[50] : '#ebebeb',
          background: theme.palette.mode === "dark" ? theme.palette.grey[50] : '#ebebeb',
          minHeight: "100vh",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Box sx={{ mb: 3 }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 600,
                color: theme.palette.text.primary,
                mb: 1,
              }}
            >
              Custodians
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: theme.palette.text.secondary,
              }}
            >
              Manage your custodian relationships and configurations
            </Typography>
          </Box>

          <Card
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              border: `1px solid ${theme.palette.divider}`,
            }}
          >
            <CustodianTable
              custodians={custodians || []}
              onAdd={handleAdd}
              onDelete={handleDelete}
              onEdit={handleEdit}
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
              page={page}
              onPageChange={setPage}
              pageSize={pageSize}
              onPageSizeChange={setPageSize}
            />
          </Card>
        </Container>

        <CustodianDialog
          open={openDialog}
          onClose={handleCloseDialog}
          onSave={handleSave}
          custodian={recordForEdit}
        />
      </Box>
    </>
  );
};

export default Custodian;
